<template lang="pug">
  .camps-page
    router-view
    .preloader-gif(
      v-if="isPending"
    )
</template>
<script>

export default {
  name: "CampsPage",
  data() {
    return {
      isPending: true
    };
  },
  mounted() {
    this.$root.$on("on-show-preloader", () => {
      this.isPending = true;
    });
    this.$root.$on("on-hide-preloader", () => {
      this.isPending = false;
    });
  },
  beforeDestroy() {
    this.$root.$off("onShowPreloader");
    this.$root.$off("onHidePreloader");
  }
};
</script>
